<section class="index-banner-inner pad" style="background-image: url(assets/images/Reg_form.jpg);">
	<div class="container-fluid">
		<div class="container">
			<h2 class="title-banner mbtm20">Contact Us</h2>
		</div>
	</div>
</section>
<section class="pt-70 pb-70">
	<div class="container-fluid" style="padding:0px">
		<div class="container">
			<div class="row">
				<div class="col-md-8">
					<div class="card card-outline-secondary">
						<div class="card-header">
							<h5 class="mb-0">Contact Us</h5>
						</div>
						<div class="card-body">
							<form id ="contact_form" [formGroup]="contactForm" (ngSubmit)="onSubmit()">
							<div class="row">
								<div class="form-group col-md-6">
									<label>Organization Name <span class="red">*</span></label>
									<input type="text" [(ngModel)]="contactDetails.orgName" class="form-control" formControlName="orgName" [ngClass]="{ 'is-invalid': submitted && f.orgName.errors }" />
									<div *ngIf="submitted && f.orgName.errors" class="invalid-feedback">
										<div *ngIf="f.orgName.errors.required">Organization Name is required</div>
										<div *ngIf="f.orgName.errors.pattern">Organization Name must contain alpha numeric & space only</div>
										<div *ngIf="f.orgName.errors.noWhiteSpace">Blank spaces are not allowed</div>
										<div *ngIf="f.orgName.errors.maxlength">Please enter upto 100 characters</div>
									</div>
								</div>
								<div class="form-group col-md-6">
									<label for="name">Contact Person Name <span class="red">*</span></label>
									<input type="text" [(ngModel)]="contactDetails.contactName" class="form-control" formControlName="contactName" [ngClass]="{ 'is-invalid': submitted && f.contactName.errors }" />
									<div *ngIf="submitted && f.contactName.errors" class="invalid-feedback">
										<div *ngIf="f.contactName.errors.required">Contact Person Name is required</div>
										<div *ngIf="f.contactName.errors.pattern">Contact Person Name must contain alpha characters only</div>
										<div *ngIf="f.contactName.errors.maxlength">Please enter upto 50 characters</div>
										<div *ngIf="f.contactName.errors.noWhiteSpace">Blank spaces are not allowed</div>
									</div>
								</div>
								<div class="form-group col-md-6">
									<label for="email">Email ID <span class="red">*</span></label>
									<input type="text" [(ngModel)]="contactDetails.contactEmail" class="form-control" formControlName="contactEmail" [ngClass]="{ 'is-invalid': submitted && f.contactEmail.errors }" />
									<div *ngIf="submitted && f.contactEmail.errors" class="invalid-feedback">
										<div *ngIf="f.contactEmail.errors.required">Email ID is required</div>
										<!-- <div *ngIf="f.contactEmail.errors.email">Email must be a valid email address</div> -->
										<div *ngIf="f.contactEmail.errors.pattern">Email ID must be a valid email address</div>
										<div *ngIf="f.contactEmail.errors.noWhiteSpace">Blank spaces are not allowed</div>
									</div>
								</div>
								<div class="form-group col-md-6">
									<label>Contact Number <span class="red">*</span></label>
									<input type="text" [(ngModel)]="contactDetails.contactNumber" class="form-control" formControlName="contactNumber" [ngClass]="{ 'is-invalid': submitted && f.contactNumber.errors }" />
									<div *ngIf="submitted && f.contactNumber.errors" class="invalid-feedback">
										<div *ngIf="f.contactNumber.errors.required">Contact Number is required</div>
										<div *ngIf="f.contactNumber.errors.pattern">Please enter valid contact number</div>
										<div *ngIf="f.contactNumber.errors.noWhiteSpace">Blank spaces are not allowed</div>
									</div>
								</div>
								<div class="form-group col-md-6">
									<label>Designation</label>
									<input type="text" [(ngModel)]="contactDetails.designation" class="form-control" formControlName="designation" [ngClass]="{ 'is-invalid': submitted && f.designation.errors }" />
									<div *ngIf="submitted && f.designation.errors" class="invalid-feedback">
										<div *ngIf="f.designation.errors.required">Designation is required</div>
										<div *ngIf="f.designation.errors.pattern">Designation must contain alpha characters & space only</div>
										<div *ngIf="f.designation.errors.noWhiteSpace">Blank spaces are not allowed</div>
										<div *ngIf="f.designation.errors.maxlength">Please enter upto 100 characters</div>
									</div>
								</div>
								<div class="form-group col-md-6">
									<label for="uname1">Enquiry For <span class="red">*</span></label>
									<select class="form-control" [(ngModel)]="contactDetails.enquiryType" formControlName="enquiryType" [ngClass]="{ 'is-invalid': submitted && f.enquiryType.errors }">
										<option value="">Choose</option>
										<option value="General">General</option>
										<option value="Book for demo">Book for demo</option>
										<option value="Free trail">Free trail</option>
									</select>
									<div *ngIf="submitted && f.enquiryType.errors" class="invalid-feedback">
										<div *ngIf="f.enquiryType.errors.required">Please choose Enquiry For</div>
									</div>
								</div> 
								<div class="form-group col-md-6">
									<label>Comments</label>
									<input type="text" [(ngModel)]="contactDetails.comments" class="form-control" formControlName="comments" [ngClass]="{ 'is-invalid': submitted && f.comments.errors }"/>
									<div *ngIf="submitted && f.comments.errors" class="invalid-feedback">
										<div *ngIf="f.comments.errors.required">Comments is required</div>
										<div *ngIf="f.comments.errors.pattern">Comments must contain alpha characters & space only</div>
										<div *ngIf="f.comments.errors.noWhiteSpace">Blank spaces are not allowed</div>
										<div *ngIf="f.comments.errors.maxlength">Please enter upto 500 characters</div>
									</div>
								</div>
								<recaptcha 
									[size]="'invisible'"
									[hide]="true" 
									(captchaResponse)="onCaptchaResponse($event)">
								</recaptcha>
								<!-- captcha challenge: placeholder 
								<div class="form-group" style="text-align: center;">
									<botdetect-captcha captchaStyleName="angularBasicCaptcha"></botdetect-captcha>
								</div>
								<div class="form-group">
									<!-- <label>Retype the chars long from the picture:</label> 
									<input type="text" [(ngModel)]="contactDetails.userCaptchaInput" id="userCaptchaInput" name="userCaptchaInput" class="form-control" formControlName="userCaptchaInput" placeholder="Enter captcha" [ngClass]="{ 'is-invalid': submitted && f.userCaptchaInput.errors }" />
									<div *ngIf="submitted && f.userCaptchaInput.errors" class="invalid-feedback">
										<div *ngIf="f.userCaptchaInput.errors.required">Please enter Captcha</div>
										<div *ngIf="f.userCaptchaInput.errors.incorrect">Please enter correct Captcha</div>
									</div>
								</div> -->
								<input type="hidden" [(ngModel)]="contactDetails.token" id="token" class="form-control" formControlName="token" />
								</div>
								<hr>
							<div class="row">
							<div class="col-md-12 text-center">
									<button class="btn btn-primary btn-md" [disabled]="isDisabled">Submit</button>
								</div>
							</div>
							</form>
						</div>
					</div>
				</div>
				<div class="col-md-4">
					<div class="contact-details">
						<p>
							<span><img src="assets/images/mail-blue.png" /></span> ilms@interlaceindia.com
						</p>
						<p> 
							<span>
								<img src="assets/images/phone-blue.png" />
							</span> +91 638 090 7797
						</p>
						<p> 
							<span>
								&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
							</span> +91 638 090 7244
						</p>
					</div>
				</div>
			</div>
		</div>
	</div>
</section>